import axios from 'axios'
import { ApiConfig } from '../../config/api'
import {
  eInventoryCheckState,
  eTypeInventoryCheck
} from '../../enums/eInventoryCheck'

// ─── Tipos ────────────────────────────────────────────────────────────────────

export interface InventoryCheckUpdateUser {
  userId: number
}

// ─── Conteo / Work Order ──────────────────────────────────────────────────────

/** GET /api/InventoryCheck/{id}/user/{userId}
 *  Retorna el detalle del conteo para el usuario (summary + asignación). */
export const getInventoryCheckUserDetail = (
  inventoryCheckId: number,
  userId: number | undefined
) => {
  const url = new URL(
    `${ApiConfig.InventoryCheckApi}/${inventoryCheckId}/user/${userId}`
  )
  return axios.get(url.toString())
}

/** GET /api/InventoryCheck  — lista de ciclicos asignados al usuario */
export const getUserAssignedChecks = (userId: number) => {
  const url = new URL(`${ApiConfig.InventoryCheckApi}`)
  url.searchParams.set('userId', userId.toString())
  url.searchParams.set(
    'typeInventoryCheckId',
    eTypeInventoryCheck.Ciclicos.toString()
  )
  url.searchParams.set(
    'InventoryCheckStateId',
    eInventoryCheckState.Creada.toString()
  )
  url.searchParams.append(
    'InventoryCheckStateId',
    eInventoryCheckState['En Proceso'].toString()
  )
  url.searchParams.set('pageSize', '50')
  url.searchParams.set('pageIndex', '0')
  return axios.get(url.toString())
}

/** GET /api/InventoryCheck  — ciclicos en estado Creada(1) y En Proceso(2) */
export const getAllCyclicals = (warehouseId?: number) => {
  const url = new URL(`${ApiConfig.InventoryCheckApi}`)
  url.searchParams.set(
    'typeInventoryCheckId',
    eTypeInventoryCheck.Ciclicos.toString()
  )
  url.searchParams.set(
    'InventoryCheckStateId',
    eInventoryCheckState.Creada.toString()
  )
  url.searchParams.append(
    'InventoryCheckStateId',
    eInventoryCheckState['En Proceso'].toString()
  )
  url.searchParams.set('pageSize', '50')
  url.searchParams.set('pageIndex', '0')
  if (warehouseId) url.searchParams.set('warehouseId', warehouseId.toString())
  return axios.get(url.toString())
}

// ─── Posiciones ───────────────────────────────────────────────────────────────

/** GET /api/InventoryCheck/{id}/positions?availablePositions=true */
export const getAvailablePositions = (
  inventoryCheckId: number,
  userId: number | undefined,
  pageSize = 50
) => {
  const url = new URL(
    `${ApiConfig.InventoryCheckApi}/${inventoryCheckId}/positions?pageSize=${pageSize}&userId=${userId}&availablePositions=true`
  )
  return axios.get(url.toString())
}

/** GET /api/InventoryCheck/{id}/positions?takenPositions=true */
export const getTakenPositions = (
  inventoryCheckId: number,
  userId: number | undefined,
  pageSize = 5
) => {
  const url = new URL(
    `${ApiConfig.InventoryCheckApi}/${inventoryCheckId}/positions?pageSize=${pageSize}&userId=${userId}&takenPositions=true`
  )
  return axios.get(url.toString())
}

/** GET /api/InventoryCheck/{id}/positions?FinishedCyclePositions=true */
export const getFinishedPositions = (
  inventoryCheckId: number,
  userId: number | undefined
) => {
  const url = new URL(
    `${ApiConfig.InventoryCheckApi}/${inventoryCheckId}/positions?pageSize=100&userId=${userId}&FinishedCyclePositions=true`
  )
  return axios.get(url.toString())
}

/** PATCH /api/InventoryCheck/{id}/position/{positionId}  — asigna posición al ciclo */
export const patchInventoryCheckCycle = (
  inventoryCheckId: number,
  positionId: number
) => {
  const url = new URL(
    `${ApiConfig.InventoryCheckApi}/${inventoryCheckId}/position/${positionId}`
  )
  return axios.patch(url.toString())
}

// ─── SKU / Productos ──────────────────────────────────────────────────────────

/** GET /api/InventoryCheck/sku/{sku}?positionId={positionId} */
export const validateSkuOnInventoryCheck = (
  sku: string,
  positionId: number
) => {
  const url = new URL(
    `${ApiConfig.InventoryCheckApi}/sku/${sku}?positionId=${positionId}`
  )
  return axios.get(url.toString())
}

/** GET /api/InventoryCheck/skuBatch/{skuId} */
export const getSkuBatches = (
  skuId: number,
  page = 0,
  pageSize = 5,
  batchNumber?: string
) => {
  const url = new URL(`${ApiConfig.InventoryCheckApi}/skuBatch/${skuId}`)
  url.searchParams.set('pageIndex', page.toString())
  url.searchParams.set('pageSize', pageSize.toString())
  if (batchNumber) url.searchParams.set('batchNumber', batchNumber)
  return axios.get(url.toString())
}

/** POST /api/InventoryCheckDetailItem  — cierra el ciclo de posición */
export const closeInventoryCheckPositionCycle = (
  inventoryCheckDetailId: number,
  items: { skuId: number; checkedQty: number; batchId?: number | null }[]
) => {
  const url = new URL(`${ApiConfig.InventoryCheckDetailItemApi}`)
  return axios.post(url.toString(), {
    inventoryCheckDetailId,
    inventoryCheckDetailItems: items
  })
}

// ─── Asignación de usuario ────────────────────────────────────────────────────

/** PATCH /api/InventoryCheckDetail/{id}/User  — asigna usuario a un detalle */
export const assignUser = (
  inventoryCheckId: number,
  userId: number
) => {
  const url = new URL(
    `${ApiConfig.InventoryCheckUserApi}/${inventoryCheckId}/User/${userId}`
  )
  return axios.post(url.toString())
}

/** GET /api/InventoryCheckUser/AvailableUsers/{inventoryCheckDetailId} */
export const getAvailableUsers = (inventoryCheckDetailId: number) => {
  const url = new URL(
    `${ApiConfig.InventoryCheckUserApi}/AvailableUsers/${inventoryCheckDetailId}`
  )
  return axios.get(url.toString())
}
